import { render, staticRenderFns } from "./orderPurchaselist.vue?vue&type=template&id=f285df16&"
import script from "./orderPurchaselist.vue?vue&type=script&lang=js&"
export * from "./orderPurchaselist.vue?vue&type=script&lang=js&"
import style0 from "./orderPurchaselist.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports